// src/components/EditDialog.js
import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';

const EditDialogEngineClass = ({
    open,
    handleClose,
    type, // 'brand' or 'model'
    currentData,
    brands,
    handleSave,
}) => {
    const [name, setName] = useState('');
    const [Id, setId] = useState('');
    const [Oil, setOil] = useState('');
    useEffect(() => {
        console.log('edit oil dia')
         
        if (currentData) {
            setName(currentData.name || '');
            setId(currentData.id || '');
            setOil(currentData.oilQuantity || '');
        }
    }, [currentData]);

    const onSave = () => {

        if (type === 'engine') {
            if (name.trim() === '' || Id === '') {
                alert('Engine Class selection cannot be empty.');
                return;
            }
            handleSave({ ...currentData, name: name.trim(), id: Id, oilQuantity: Oil });
        }
        handleClose();
    };





    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Edit Engine Class</DialogTitle>
            <DialogContent>
                <TextField
                    label="Engine Class"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    fullWidth
                    margin="dense"
                />
                {type === 'engine' && (
                    <FormControl fullWidth margin="dense">

                        <TextField
                            label="Oil Quantity"
                            value={Oil}
                            onChange={(e) => setOil(e.target.value)}
                            fullWidth
                            margin="dense"
                        />
                    </FormControl>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={onSave}
                    color="primary"
                    variant="contained"
                    disabled={type === 'brand' ? name.trim() === '' : name.trim() === '' || Id === ''}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditDialogEngineClass;
